/*
Copyright 2018 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/*
 * THIS FILE IS AUTO-GENERATED
 * You can edit it you like, but your changes will be overwritten,
 * so you'd just be trying to swim upstream like a salmon.
 * You are not a salmon.
 */

let components = require('matrix-react-sdk/lib/component-index').components;
if (!components) {
    throw new Error("'matrix-react-sdk/lib/component-index' didn't export components");
}
import structures$VectorEmbeddedPage from './components/structures/VectorEmbeddedPage';
structures$VectorEmbeddedPage && (components['structures.VectorEmbeddedPage'] = structures$VectorEmbeddedPage);
import views$auth$VectorAuthFooter from './components/views/auth/VectorAuthFooter';
views$auth$VectorAuthFooter && (components['views.auth.VectorAuthFooter'] = views$auth$VectorAuthFooter);
import views$auth$VectorAuthHeaderLogo from './components/views/auth/VectorAuthHeaderLogo';
views$auth$VectorAuthHeaderLogo && (components['views.auth.VectorAuthHeaderLogo'] = views$auth$VectorAuthHeaderLogo);
import views$auth$VectorAuthPage from './components/views/auth/VectorAuthPage';
views$auth$VectorAuthPage && (components['views.auth.VectorAuthPage'] = views$auth$VectorAuthPage);
import views$auth$VectorCustomServerDialog from './components/views/auth/VectorCustomServerDialog';
views$auth$VectorCustomServerDialog && (components['views.auth.VectorCustomServerDialog'] = views$auth$VectorCustomServerDialog);
export {components};
